export const Salutations = Object.freeze({
    Company: 1,
    Mrs: 2,
    Mr: 3
});

export const CarTypes = Object.freeze({
    PKW: "PKW",
    SUV: "SUV",
    LLKW: "LLKW"
});

export const Seasons = Object.freeze({
    Summer: "Summer",
    Winter: "Winter",
    AllYear: "AllYear"
});

export const RimTypes = Object.freeze({
    Steel: "Steel",
    Aluminium: "Aluminium"
});